<template lang="pug">
  .gl-alert

    // errors
    .alert.alert-danger.alert-dismissible(v-if="options.errorList && options.errorList.length" role="alert")
      button.close(@click="clear('errorList')" type="button" data-dismiss="alert" aria-label="Close")
        span(aria-hidden="true") &times;
      ul(v-if="options.errorList.length > 1")
        li(v-for="message in options.errorList")
          span(v-if="!options.includesHtml") {{ message }}
          span(v-if="options.includesHtml" v-html="message")
      div(v-if="options.errorList.length === 1")
        span(v-if="!options.includesHtml") {{ options.errorList[0] }}
        span(v-if="options.includesHtml" v-html="options.errorList[0]")

    // success
    .alert.alert-success.alert-dismissible(v-if="options.successList && options.successList.length" role="alert")
      button.close(@click="clear('successList')" type="button" data-dismiss="alert" aria-label="Close")
        span(aria-hidden="true") &times;
      ul(v-if="options.successList.length > 1")
        li(v-for="message in options.successList")
          span(v-if="!options.includesHtml") {{ message }}
          span(v-if="options.includesHtml" v-html="message")
      div(v-if="options.successList.length === 1")
        span(v-if="!options.includesHtml") {{ options.successList[0] }}
        span(v-if="options.includesHtml" v-html="options.successList[0]")

    // info
    .alert.alert-info.alert-dismissible(v-if="options.infoList && options.infoList.length" role="alert")
      button.close(@click="clear('infoList')" type="button" data-dismiss="alert" aria-label="Close")
        span(aria-hidden="true") &times;
      ul(v-if="options.infoList.length > 1")
        li(v-for="message in options.infoList")
          span(v-if="!options.includesHtml") {{ message }}
          span(v-if="options.includesHtml" v-html="message")
      div(v-if="options.infoList.length === 1")
        span(v-if="!options.includesHtml") {{ options.infoList[0] }}
        span(v-if="options.includesHtml" v-html="options.infoList[0]")

    // warning
    .alert.alert-warning.alert-dismissible(v-if="options.warningList && options.warningList.length" role="alert")
      button.close(@click="clear('warningList')" type="button" data-dismiss="alert" aria-label="Close")
        span(aria-hidden="true") &times;
      ul(v-if="options.warningList.length > 1")
        li(v-for="message in options.warningList")
          span(v-if="!options.includesHtml") {{ message }}
          span(v-if="options.includesHtml" v-html="message")
      div(v-if="options.warningList.length === 1")
        span(v-if="!options.includesHtml") {{ options.warningList[0] }}
        span(v-if="options.includesHtml" v-html="options.warningList[0]")
</template>

<script>
export default {

  // props
  props: {
    options: Object
  },

  // methods
  methods: {
    clear (src) {
      // maps src to events we'll emit
      const SRC_EVENT_MAP = {
        infoList: 'clear-info-list',
        errorList: 'clear-error-list',
        warningList: 'clear-warning-list',
        successList: 'clear-success-list'
      }

      // $emit
      this.$emit(SRC_EVENT_MAP[src])
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/gl-alert.vue